import _ExamLabel from "./ExamLabel";
import _MenuLateral from "./MenuLateral";
import _TitleHeader from "./TitleHeader";
import _Searcher from "./Searcher";
import _TableAntd from "./TableAntd";
import _InputAntd from "./InputAntd";
import _Responder from "./Responder";
import _UserCard from "./UserCard";
import _ButtonDownload from "./ButtonDownload";
import _CardReport from "./CardReport";

export const ExamLabel = _ExamLabel;
export const MenuLateral = _MenuLateral;
export const TitleHeader = _TitleHeader;
export const Searcher = _Searcher;
export const TableAntd = _TableAntd;
export const InputAntd = _InputAntd;
export const Responder = _Responder;
export const UserCard = _UserCard;
export const ButtonDownload = _ButtonDownload;
export const CardReport = _CardReport;
